import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=04204c89&"
import script from "./alert.vue?vue&type=script&lang=js&"
export * from "./alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04204c89')) {
      api.createRecord('04204c89', component.options)
    } else {
      api.reload('04204c89', component.options)
    }
    module.hot.accept("./alert.vue?vue&type=template&id=04204c89&", function () {
      api.rerender('04204c89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alert/alert.vue"
export default component.exports